import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'

import { getMainEvent } from '../selectors/event';
import Translation from '../../shared/Translation';
import {EMBED_TYPE_MULTI} from "../reducers/ui";

const translations = {
  tos_url: "checkout__terms_of_service",
  contact_url: "checkout__support",
  privacy_url: "checkout__privacy_policy",
  do_not_sell_url: "checkout__do_not_sell_or_share"
}

const EmbedFooter = ({ mainEvent, partner, isEmbed, isMultiEmbed }) => {

  const copyrightText = useMemo(() => {
    if (!partner.copyright) return;

    const year = partner?.copyright_year ?? new Date().getFullYear();
    let copyrightText = `${year} ${partner.copyright}`
    
    if (partner.copyright_behalf) {
      return (
        <Translation
          interpolation={{
            copyright: copyrightText,
            partner: partner.copyright_behalf
          }}
        >
          {"checkout__copyright"}
        </Translation>
      );
    }

    return copyrightText;
  }, [partner]);

  const getLink = (type) => {
    const event = mainEvent;
    return event ? event?.[type] : partner?.[type];
  }

  const links = useMemo(() => ({
    tos_url: getLink('tos_url'),
    privacy_url: getLink('privacy_url'),
    contact_url: getLink('contact_url'),
    do_not_sell_url: getLink('do_not_sell_url'),
    hide_nav_bar_logo: getLink('hide_nav_bar_logo'),
  }), [mainEvent, parent, getLink]);

  if (!isEmbed || isMultiEmbed) {
    return null;
  }

  return (
    <div className="embed__footer">
      <div className="footer__inner">
        {!links.hide_nav_bar_logo && (
          <a href={links.contact_url} target="_blank" className="footer__branding__image">
              <span className="sr-only">{partner.name}</span>
          </a>
        )}
        <div className="footer__links">
          {Object.entries(links).filter(([, link]) => !!link).map(([key, link]) => (
            <p key={key}>
              <a href={link} target="_blank"><Translation>{translations[key]}</Translation></a>
            </p>
          ))}
        </div>
        {copyrightText && <p className="copyright-text">&copy; {copyrightText}</p>}
      </div>
    </div>
  )
}

EmbedFooter.propTypes = {
  isEmbed: PropTypes.bool,
  isMultiEmbed: PropTypes.bool,
  partner: PropTypes.shape({
    copyright_behalf: PropTypes.string,
    copyright_year: PropTypes.string,
    copyright: PropTypes.string,
    name: PropTypes.string
  }),
  mainEvent: PropTypes.shape({
    tos_url: PropTypes.string,
    privacy_url: PropTypes.string,
    contact_url: PropTypes.string,
    do_not_sell_url: PropTypes.string
  })
}

const mapStateToProps = (state) => {
  return {
      isEmbed: state.ui?.isEmbed,
      isMultiEmbed: !!state.ui?.isEmbed && state.ui?.embedType === EMBED_TYPE_MULTI,
      partner: state.partner,
      mainEvent: getMainEvent(state)?.event ?? null,
  };
}

export default connect(mapStateToProps)(EmbedFooter);
